module.exports = __webpack_public_path__ + "static/media/whatsapp.a1a725f2.svg";